/**
 * Maps the flat status to class.
 * @param {string} status - The status slug of the flat.
 * @returns {string} - The corresponding CSS class.
*/
export const mapFlatStatusClass = (status: string): string => {
    switch (status) {
        case 'dostepne':
            return 'available';
        case 'rezerwacja':
            return 'reservation';
        case 'sprzedane':
            return 'sold';
        default:
            return '';
    }
};

/**
 * Maps the flat status to text.
 * @param {string} status - The status slug of the flat.
 * @returns {string} - The status text for display.
*/
export const mapFlatStatusText = (status: string): string => {
    switch (status) {
        case 'dostepne':
            return 'Dostępne';
        case 'rezerwacja':
            return 'Rezerwacja';
        case 'sprzedane':
            return 'Sprzedane';
        default:
            return '';
    }
};

/**
 * Maps the floor slug to its corresponding display name or number.
 * @param {string} slug - The slug floor slug.
 * @returns {string} - The floor display name.
*/
export const mapFloorNumber = (slug: string): string => {
    switch (slug) {
        case 'parter':
            return 'Parter';
        case 'pietro_1':
            return '1';
        case 'pietro_2':
            return '2';
        case 'pietro_3':
            return '3';
        case 'pietro_4':
            return '4';
        case 'pietro_5':
            return '5';
        case 'pietro_6':
            return '6';
        default:
            return '-';
    }
};